// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3JRKc","choiceBoxes":"toolbarselects_choiceBoxes__1y69I","simpleField":"toolbarselects_simpleField__2QNEQ"};